<template>
  <div class="ac-body-container">
    <div class="settings-container">
      <div class="settings-title-container">
        <span class="settings-title">Settings</span>
      </div>
      <div class="settings-info-container">
        <div class="settings-info-content">
          <div>
            <div class="settings-info-txt">
              Preferred Plan: {{ preferredPlanName }}
            </div>
          </div>
          <div class="settings-info-row ">
            <span class="cc-note">
              Mark one of your plans as your best-seller.
            </span>
          </div>
        </div>
        <button
          v-if="adminRole === 'admin'"
          type="button"
          class="edit-btn"
          @click="handleToggle(true, 'preferred-plan')"
        >
          <img
            src="@shared/assets/img/general/edit-white.svg"
            alt="edit"
          >
        </button>
      </div>
      <div class="settings-info-container">
        <div class="settings-info-content">
          <div>
            <div class="settings-info-txt">
              Reward Points are referred to as:
              <span class="loyalty-name">{{ loyaltyName }}
              </span>
            </div>
          </div>
          <div class="settings-info-row ">
            <span class="cc-note">
              * SmartAC.com refers to Reward Points as Comfort Credits
            </span>
          </div>
        </div>
        <button
          v-if="adminRole === 'admin'"
          type="button"
          class="edit-btn"
          @click="handleToggle(true, 'loyalty')"
        >
          <img
            src="@shared/assets/img/general/edit-white.svg"
            alt="edit"
          >
        </button>
      </div>
    </div>
    <ActionModal
      :actionModalView="actionModalView"
      :showActionModal="showActionModal"
      :close="() => handleToggle(false, '')"
      :partnerSettings="partnerSettings"
      :update="update"
    />
  </div>
</template>

<script>
import providerPlanMixin from '@shared/mixins/providerPlanMixin';
import ActionModal from './comfortCredit/ActionModal.vue';

export default {
  name: 'CustomComfortCredit',
  components: {
    ActionModal,
  },
  mixins: [providerPlanMixin],
  props: {
    partnerSettings: Object,
    adminRole: String,
    update: Function,
  },
  data() {
    return {
      showActionModal: false,
      actionModalView: '',
    };
  },
  computed: {
    loyaltyName() {
      return this.partnerSettings.LOYALTY_PROGRAM_NAME || 'Comfort Credits';
    },
    preferredPlanName() {
      const planId = this.partnerSettings?.PREFERRED_PLAN_ID || '';

      const plan = this.plans.filter((p) => p.planId === Number(planId));
      return plan.length > 0 ? plan[0].name : '--';
    },
  },
  methods: {
    handleToggle(toggle, actionModalView) {
      this.showActionModal = toggle;
      this.actionModalView = actionModalView;
    },
  },
};
</script>

<style lang="scss">

.settings-container{
  border-style: solid;
  border-color: $N10;
  border-width: 1px;
  border-radius: 8px;
  padding: 20px;
  width: 45%;
  .settings-title-container {
    border-bottom: 1px solid $N10;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .settings-title {
    font-weight: 600;
    font-size: 18px;
  }
  .settings-info-container {
    display: flex;
    border-radius: 0px;
    justify-content: space-between;
    align-items: center;
  }
  .settings-info-content {
    display: flex;
    flex-direction: column;
    border-radius: 0px;
    gap: 16px;
    padding-top: 16px;
  }
  .settings-info-row {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }
  .edit-btn {
    background: $NBLUE100;
    padding: 16px;
    border-radius: 4px;
    height: 52px;
    width: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .edit-btn-txt {
    color: $WHITE;
    font-weight: bold;
  }
  .settings-info-txt {
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
  }
  .loyalty-name {
    font-weight: 600;
    font-size: 14px;
  }
  .cc-note {
    color: $TEXT_SECONDARY;
    font-size: 12px;
    font-weight: 400;
    padding-bottom: 16px;
    line-height: 1;
  }
}
</style>
